import { render, staticRenderFns } from "./LoaderGrid.vue?vue&type=template&id=613b60e4&"
import script from "./LoaderGrid.vue?vue&type=script&lang=js&"
export * from "./LoaderGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports